import { createSlice } from '@reduxjs/toolkit';

const initialState: { isAuthorized: boolean } = {
	isAuthorized: false
};

const authorizationSlice = createSlice({
	name: 'authorizationState',
	initialState,
	reducers: {
		authorize(state) {
			return {
				...state,
				isAuthorized: true
			};
		},
		unauthorize(state) {
			return {
				...state,
				isAuthorized: false
			};
		}
	}
});

export const { authorize, unauthorize } = authorizationSlice.actions;

export default authorizationSlice;
